<div class="flex flex-col justify-start items-stretch gap-y-4 p-4 app-full-height basis-full flex-grow">
  <span class="text-lg font-bold">Transport Jobs Report</span>

  <div class="flex flex-row justify-start items-center w-full gap-x-8">
    <span class="text-sm text-gray-500 basis-full flex-shrink">
      @if (reportGenerated$ | async) {
      Currently showing results for:
      {{ from$ | async | amDateFormat:dateFormat }} - {{ to$ | async | amDateFormat:dateFormat }}
      @if((assignedTo$ | async)) {
      ({{ assignedTo$ | async | userIdToName | async }})
      }
      } @else {
      Open report settings to set the criteria and generate the report
      }
    </span>

    <button mat-raised-button (click)="openControlsDialog()" class="flex-shrink-0">Report Settings</button>
  </div>
  <div class="w-full overflow-x-auto">
    @if (reportGenerated$ | async) {
    <app-transport-job-table></app-transport-job-table>
    } @else {
    <div class="flex flex-row justify-center items-center w-full h-full">
      <span class="text-gray-500">No report generated yet</span>
    </div>
    }
  </div>
</div>